export default __webpack_public_path__ + "40d4c09e04b2b1ce57cbb089ddda308c.png";